import GameOver from './GameOver'

export default GameOver
